"use client";

import { useState } from "react";

interface PayButtonProps {
  bookingId: number;
  amount: number;
  token: string;
}

export default function PayButton({ bookingId, amount, token }: PayButtonProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handlePay() {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch("/api/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bookingId, token }),
      });
      const data = await res.json();
      if (!res.ok || !data.url) {
        setError(data.error || "Nepavyko pradėti mokėjimo.");
        setLoading(false);
        return;
      }
      window.location.href = data.url as string;
    } catch {
      setError("Ryšio klaida. Bandykite dar kartą.");
      setLoading(false);
    }
  }

  return (
    <div className="mt-4">
      <button
        type="button"
        onClick={handlePay}
        disabled={loading}
        className="w-full py-3 px-4 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {loading ? "Nukreipiama į apmokėjimą..." : `Apmokėti ${amount.toFixed(2)} €`}
      </button>
      {error && <p className="mt-2 text-sm text-red-700">{error}</p>}
      <p className="mt-2 text-xs text-green-700 text-center">Saugus apmokėjimas per Stripe.</p>
    </div>
  );
}
